import { useDispatch, useSelector } from "react-redux";
import { updateAlertStatus } from "../../redux/actions/updateAlertStatusAction";
import Button from "@material-ui/core/Button";
import { isNull } from "lodash";
import {
  CREATE_JIRA_INCIDENT,
  DISPLAY_SYS_GUARD_ALERT_COMMENT,
  OPEN_SYS_GUARD_SNACKBAR,
  reportIncidentFailed,
  SET_SYS_GUARD_ALERT_STATUS,
} from "./sysGuardConstants";
import { Snackbar } from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";
import { use, useState } from "react";
import { renderRevokePopup } from "../../components/common/utilities";

export const SysGuardAlertButtons = ({ alertData, dataSourceId }) => {
  const alertId = alertData?.alertId || null;
  const alertStatus = useSelector((state) => state.SysGuardReducer.alertStatus);
  const displayAlertComment = useSelector(
    (state) => state.SysGuardReducer.displayAlertComment
  );
  const reportIncidentData = useSelector(
    (state) => state.SysGuardReducer.reportIncidentData
  );
  const dispatch = useDispatch();
   const [revokeDetails, setRevokeDetails] = useState(null);
   const [revokePopup, setRevokePopup] = useState(false);

   const handleRevokePopupClose = () => {
     setRevokePopup(false);
   };
   const handleRevokeConfirm = () => {
     dispatch({
       type: CREATE_JIRA_INCIDENT,
       payload: {
         alerts: [{ alertId: alertId, dataSourceID: dataSourceId }],
       },
     });
     setRevokePopup(false);
   };


  const renderReportIncident = () => {
  if ((reportIncidentData?.length > 0) || alertData?.ticketIds) {
    return (
      <div className="incident-ticket">
        {reportIncidentData?.[0]?.ticketId || alertData?.ticketIds}
      </div>
    );
  } else {
    return (
      <Button
        onClick={() => {
         setRevokePopup(true);
        }}
        disabled={isNull(alertId)}
      >
        Report Incident
      </Button>
    );
  }
};

  return (
    <div className="sys-guard-alert-buttons">
      {renderReportIncident()}
      <Button
        onClick={() => {
          dispatch({
            type: SET_SYS_GUARD_ALERT_STATUS,
            payload: "MARK_RESOLVED",
          });
          dispatch({
            type: DISPLAY_SYS_GUARD_ALERT_COMMENT,
            payload: true,
          });
        }}
        className={
          !isNull(alertStatus) &&
          alertStatus === "MARK_RESOLVED" &&
          displayAlertComment
            ? "alertSelected"
            : ""
        }
        disabled={isNull(alertId)}
      >
        Resolve
      </Button>
      <Button
        onClick={() => {
          dispatch({
            type: SET_SYS_GUARD_ALERT_STATUS,
            payload: "MARK_FALSE_POSITIVE",
          });
          dispatch({
            type: DISPLAY_SYS_GUARD_ALERT_COMMENT,
            payload: true,
          });
        }}
        className={
          !isNull(alertStatus) &&
          alertStatus === "MARK_FALSE_POSITIVE" &&
          displayAlertComment
            ? "alertSelected"
            : ""
        }
        disabled={isNull(alertId)}
      >
        False Positive
      </Button>
      {renderRevokePopup(
        revokePopup,
        revokeDetails,
        handleRevokePopupClose,
        handleRevokeConfirm,
        "behavioralAnomalies"
      )}
    </div>
  );
};

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export const AlertStatusSnackBar = () => {
  const dispatch = useDispatch();
  const snackBarSuccessMessage = useSelector(
    (state) => state.alertStatusChanged.successMessage
  );
  const snackBarFailedMessage = useSelector(
    (state) => state.alertStatusChanged.unsuccessful
  );
  const alertUpdated = useSelector(
    (state) => state.alertStatusChanged.alertUpdated
  );
  const openSnackbar = useSelector(
    (state) => state.SysGuardReducer.openSysGuardSnackBar
  );

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    dispatch({ type: OPEN_SYS_GUARD_SNACKBAR, payload: false });
    dispatch({ type: "CLEAR_ERROR" });
    dispatch({ type: "CLOSE_SNACKBAR" });
  };
  return (
    <Snackbar
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={openSnackbar}
      autoHideDuration={3000}
      onClose={handleCloseSnackbar}
    >
      <Alert onClose={handleCloseSnackbar} severity={alertUpdated ? "success" : "error"}>
        {alertUpdated ? snackBarSuccessMessage : snackBarFailedMessage}
      </Alert>
    </Snackbar>
  );
};
